export const baseURL = window.location.origin
export const baseApiUrl = `${baseURL}/api/v2`

